<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 mt-4" style="position: relative">
      <div style="display: flex; align-items: center">
        <span
          ><v-btn
            icon
            color="primary"
            to="/weserve_admin_login/-/reportdashboard/main"
            class="pa-4"
          >
            <v-icon color="black">arrow_back</v-icon></v-btn
          ></span
        >
        <span class="main-title">MAIN DASHBOARD | &nbsp;</span>
        <span class="submain-title">Reward Report</span>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <download-excel
          :data="export_reward_format"
          :fields="{
            No: 'No',
            Name: 'campaign_name',
            Category: 'campaign_service_type',
            Amount: 'amount',
            'Used/Cancel': 'used',
            'Value price(THB)': 'total_value_price',
            'Paid price(THB)': 'total_paid_price',
          }"
          :name="
            'RewardReport_' +
              search_config.datetime_start +
              '_to_' +
              search_config.datetime_end +
              '.xls'
          "
          style="margin-right: 50px"
        >
          <v-btn icon> <v-icon large color="black">print</v-icon>.xls </v-btn>
        </download-excel>

        <download-excel
          type="csv"
          :data="export_reward_format"
          :fields="{
            No: 'No',
            Name: 'campaign_name',
            Category: 'campaign_service_type',
            Amount: 'amount',
            'Used/Cancel': 'used',
            'Value price(THB)': 'total_value_price',
            'Paid price(THB)': 'total_paid_price',
          }"
          :name="
            'RewardReport_' +
              search_config.datetime_start +
              '_to_' +
              search_config.datetime_end +
              '.csv'
          "
          style=""
        >
          <v-btn icon> <v-icon large color="black">print</v-icon>.csv </v-btn>
        </download-excel>
      </div>
    </div>
    <searchDateStartToEnd
      :searching="searching"
      @search="searchList()"
      action_method="report"
      :province="true"
    />
    <rewardReportList />
  </div>
</template>

<script>
import { mapState } from "vuex";
import searchDateStartToEnd from "@/components/back-office/Report/SearchBar/SearchDateStartToEnd";
import rewardReportList from "@/components/back-office/Report/MainDashboard/RewardReportList.vue";

export default {
  data() {
    return {
      searching: false,
    };
  },
  components: {
    rewardReportList,
    searchDateStartToEnd,
  },
  destroyed() {
    this.$store.commit("report/resetState");
  },
  computed: {
    ...mapState({
      export_reward_format: (state) => state.report.export_reward_format,
      search_config: (state) => state.report.clone_config_path,
    }),
  },
  methods: {
    async searchList() {
      this.searching = true;
      if (this.$store.state.report.config_path.district_id[0] == 0) {
        await this.$store.dispatch(
          "report/fetchReportList",
          this.$store.state.report.config_path
        );
      } else {
        await this.$store.dispatch("report/fetchRewardReportByDistrict");
      }
      this.searching = false;
    },
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard",
      },
      {
        text: "Reward report",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
</style>
